const ZEKAY_STATIC_DEV = "https://zekay-dev-files.s3.fr-par.scw.cloud";
const ZEKAY_STATIC_PROD = "https://zekay-prod-files.s3.fr-par.scw.cloud";

export function getZekayStaticFilesBase(): string {
  const override = (import.meta.env.VITE_STATIC_FILES_BASE_URL || "").trim();
  const appEnv = (import.meta.env.VITE_APP_ENV || "").trim().toLowerCase();

  if (override) {
    return override.replace(/\/$/, "");
  }

  if (appEnv === "prod" || appEnv === "production") {
    return ZEKAY_STATIC_PROD;
  }

  return ZEKAY_STATIC_DEV;
}

function staticAssetURL(...pathSegments: string[]): string {
  const base = getZekayStaticFilesBase();
  const path = pathSegments.map((s) => encodeURIComponent(s)).join("/");
  return `${base}/${path}`;
}

export const zekayStaticBranding = {
  chromeBlackWebp: (): string => staticAssetURL("images", "Google Chrome Black.webp"),
  karapazWebp: (): string => staticAssetURL("images", "karapaz.webp"),
  zekayIconPng: (): string => staticAssetURL("images", "zekay_icon.png"),
};
